import React from 'react';
import PropTypes from 'prop-types';

import { getReadingTime } from '@src/utils/calculations';
import { parseAuthorsMarkdownToObject } from '@src/utils/parsers';

import { Link } from '@commons/link/Link';

import Image from '@commons/image/Image';

import * as styles from './blog-post-preview.module.scss';

const lengthOfTitle = 70;

export const BlogPostPreview = ({ frontmatter: { path, title, authors, thumbnail }, wordCount: { words } }) => {
  const readingTime = getReadingTime(words);
  const authorData = parseAuthorsMarkdownToObject(authors);
  const shorthenTitle = title.length > lengthOfTitle ? `${title.substr(0, lengthOfTitle - 3)}...` : title;

  return (
    <Link href={path} className={styles.blogpost}>
      <img loading="lazy" src={thumbnail.publicURL} alt={title} className={styles.background} />
      {readingTime && <div className={styles.readingTime}>{readingTime}</div>}
      <div className={styles.title}>{shorthenTitle}</div>
      {authors && (
        <div className={styles.author}>
          <Image image={authorData?.avatar} alt={authorData?.name} className={styles.avatar} />
          <div className={styles.name}>{authorData?.name}</div>
        </div>
      )}
    </Link>
  );
};

BlogPostPreview.propTypes = {
  frontmatter: PropTypes.exact({
    path: PropTypes.string,
    title: PropTypes.string,
    authors: PropTypes.arrayOf(
      PropTypes.exact({
        frontmatter: PropTypes.exact({
          avatar: PropTypes.shape({
            publicURL: PropTypes.string,
          }),
          name: PropTypes.string,
          surname: PropTypes.string,
        }),
      }),
    ),
    thumbnail: PropTypes.shape({
      publicURL: PropTypes.string,
    }).isRequired,
  }).isRequired,
  wordCount: PropTypes.exact({
    words: PropTypes.number,
  }).isRequired,
};
